{
  "de": {
    "inspiration": {
      "actions": {
        "delete": "Entfernen",
        "deleteMultipleInspirations": "Löschen …",
        "delete_cancel": "Löschen rückgängig machen",
        "goBackToInspirationLists": "Inspirationen",
        "new": "Foto hinzufügen"
      },
      "labels": {
        "move_to_upload": "Legen Sie die Fotos in das Feld unten oder klicken Sie, um sie hochzuladen.",
        "noInspirations": "Noch keine Inspirationen",
        "upload_autoclose": "Dieses Fenster wird automatisch geschlossen, sobald alle Bilder hochgeladen sind."
      },
      "toasts": {
        "upload_success": "{count} Inspiration erfolgreich hochgeladen | {count} Inspirationen erfolgreich hochgeladen"
      }
    }
  }
}
